<template>
    <div class="mp-wrap">
        <div class="mp-top">
            <button class="icon-btn" @click="$emit('back')">
                <img src="@/assets/mobile/icon/back.png" alt="Back" >
            </button>
            <button class="icon-btn" @click="$emit('close')">
                <img src="@/assets/mobile/icon/close.png" alt="Close">
            </button>
        </div>
        <div class="mp-breadcrumb">
            <span class="mp-crumb" @click="$emit('back')">{{ secMenu.title=='ABOUT'?'Info':'Info' | capitalize }}</span>
            <span class="mp-crumb-active" v-if="secMenu.thirdTitel">{{ secMenu.thirdTitel | uppercase }}</span> 
        </div>
        <div class="mp-menu">
            <div class="mp-grid-item" v-for="(item, idx) in items" :key="idx" @click="openItem(item)">
                <div class="mp-img-wrap">
                    <img :src="item.image || defaultImage" :alt="item.label">
                </div>
                <div class="mp-menu-text">{{ item.label }}</div>
            </div>
        </div>
        <!-- 底部logo -->
        <!-- <div class="mp-logo-wrap">
            <img src="@/assets/mobile/icon/miniLogo.svg" alt="Logo">
        </div> -->
		 
    </div>
</template>

<script>
 
export default {
    name: 'MenuSec',
    props: {
        secMenu: {
            type: Object,
            default: () => ({
                title: '',
                thirdTitel: ''
            })
        },
        items: {
            type: Array,
            default: () => []
        }
    },
    data() {
        return {
            defaultImage: ''
        }
    },
    methods: {
        openItem(item) {
            if (item && item.route) {
                this.$router.push({ name: item.route })
            }
            this.$emit('close')
        }
    },
    filters: {
        capitalize: function (value) {
            if (!value) return ''
            value = value.toString()
            return value.charAt(0).toUpperCase() + value.slice(1)
        },
        uppercase: function (value) {
            if (!value) return ''
            return value.toString().toUpperCase()
        }
    }
}
</script>

<style scoped>
.mp-wrap {
    display: flex;
    flex-direction: column;
    font-family: 'Apercu-Medium', sans-serif;
    min-height: 70vh;
    padding: 0rem !important;
    padding-top: 32rem !important;
}

.mp-top {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0 23rem;
}

.icon-btn {
    background: none;
    border: none;
    padding: 0;
    height: 15rem;
    width: 12rem;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 18rem;
    color: #000;
}

.mp-breadcrumb {
    display: flex;
    align-items: center;
    gap: 65rem;
    padding: 62rem 23rem 25rem 23rem;
}

.mp-crumb {
    font-size: 14rem;
    font-weight: 500;
    color: #999;
}

.mp-crumb-active {
    font-size: 14rem;
    font-weight: 500;
    color: #000;

}

.mp-menu {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 4rem;
    padding: 0 15rem;
}

.mp-grid-item {
    display: flex;
    flex-direction: column;
    padding-bottom: 20rem;
}

.mp-img-wrap {
    width: 100%;
    max-height: 244rem;
    aspect-ratio: 168 / 222;
    background: #f5f5f5;
    margin-bottom: 9rem;
}

.mp-img-wrap img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    display: block;
}

.mp-menu-text {
    font-size: 10rem;
    font-weight: 500;
    color: #000;
}

.mp-logo-wrap {
    width: 100%;
    display: flex;
    justify-content: center;
    position: absolute;
    bottom: 60rem;
}

.mp-logo-wrap img{
    min-width: 25rem;
    max-width: 25rem;
    max-height: 30rem;
}
</style>
